<template>
  <div>
    <CRow>
      <CCol sm="6">
        <CCard>
          <CCardHeader>
            <strong>Profile</strong>
          </CCardHeader>
          <CForm novalidate>
            <CCardBody>
              <CAlert
                :color="alert.type"
                closeButton
                :show.sync="alert.show"
              >
                {{ alert.content }}
              </CAlert>
              <CRow>
                <CCol md="6">
                  <div :class="{'loading-card' : loading.card}">
                    <CInput
                      type="text"
                      label="Nama Bisnis"
                      v-model="data.business_name"
                      :invalid-feedback="errors.business_name ? errors.business_name[0]:''"
                      :is-valid="errors.business_name ? false:null"
                    />
                  </div>
                </CCol>
                <CCol md="6">
                  <div :class="{'loading-card' : loading.card}">
                    <CInput
                      type="text"
                      label="Penanggung Jawab"
                      v-model="data.pic"
                      :invalid-feedback="errors.pic ? errors.pic[0]:''"
                      :is-valid="errors.pic ? false:null"
                    />
                  </div>
                </CCol>
              </CRow>
              <CRow>
                <CCol md="6">
                  <div :class="{'loading-card' : loading.card}">
                    <CInput
                      type="email"
                      label="Email"
                      v-model="customer.email"
                      :invalid-feedback="errors.email ? errors.email[0]:''"
                      :is-valid="errors.email ? false:null"
                      readonly
                    />
                  </div>
                </CCol>
                <CCol md="6">
                  <div :class="{'loading-card' : loading.card}">
                    <CInput
                      type="tel"
                      label="No. Handphone"
                      v-model="data.phone"
                      :invalid-feedback="errors.phone ? errors.phone[0]:''"
                      :is-valid="errors.phone ? false:null"
                    />
                  </div>
                </CCol>
              </CRow>
              <CRow>
                <CCol md="6">
                  <div :class="{'loading-card' : loading.card}">
                    <CInput
                      type="text"
                      label="Credit"
                      v-model="customer.credit"
                      :invalid-feedback="errors.credit ? errors.credit[0]:''"
                      :is-valid="errors.credit ? false:null"
                      readonly
                    />
                  </div>
                </CCol>
                <CCol md="6">
                  <div :class="{'loading-card' : loading.card}">
                    <CInput
                      type="text"
                      label="Tanggal Kadaluarsa"
                      v-model="customer.date_expired"
                      :invalid-feedback="errors.date_expired ? errors.date_expired[0]:''"
                      :is-valid="errors.date_expired ? false:null"
                      readonly
                    />
                  </div>
                </CCol>
              </CRow>
              <div :class="{'loading-card' : loading.card}">
                <CInput
                  type="text"
                  label="Token / API Key"
                  v-model="customer.apikey"
                  :invalid-feedback="errors.apikey ? errors.apikey[0]:''"
                  :is-valid="errors.apikey ? false:null"
                  readonly
                />
              </div>
            </CCardBody>
            <CCardFooter>
              <ButtonLoader 
                :loading="loading.submit" 
                :styled="'btn btn-primary btn-block'" 
                @click.native="submit()">
                  Simpan
              </ButtonLoader>
            </CCardFooter>
          </CForm>
        </CCard>
      </CCol>
    </CRow>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import $axios from './../../api.js'
export default {
  name: 'Deposit',
  data(){
    return {
      alert:{
        show: false,
        content: '',
        type: 'danger'
      },
      loading: {
        submit: false,
        card: true
      },
      data: {
        business_name: '',
        pic: '',
        phone: ''
      }
    }
  },
  created(){
    setTimeout(() => this.loading.card = false, 500)
  },
  computed:{
    ...mapState(['setting','errors','customer'])
  },
  methods:{
    submit(){
      this.loading.submit = true
      this.$store.commit('CLEAR_ERRORS')
      this.alert = {
        show: false,
        content: '',
        type: 'danger'
      }
      $axios.post('/customer', this.data)
      .then((response) => {
        this.loading.submit = false
        this.$store.commit('SET_CUSTOMER', response.data.data)
        this.alert = {
          show: true,
          content: 'Profile berhasil diperbarui',
          type: 'success'
        }
      }).catch((error) => {
        this.loading.submit = false
        if (error.response.status == 422) {
          this.$store.commit('SET_ERRORS', error.response.data.errors, { root: true })
        }else{
          this.alert = {
            show: true,
            content: error.response.data.message,
            type: 'danger'
          }
        }
      })
    }
  },
  mounted(){
    setTimeout(() => {
      this.data.business_name = this.customer.business_name,
      this.data.pic = this.customer.pic,
      this.data.phone = this.customer.phone
    },
    500)
    
  }
}
</script>
